export const forcedAuthGuardRoutes = ['/customer/course/']

export const shouldForceAuth = (path: string): boolean => {
  return forcedAuthGuardRoutes.some(route => path.includes(route))
}
